<!-- src/app/dashboard-grid/dashboard-grid.component.html -->
<!-- <h2>What I Care About, What I'm Doing, and What I'm Building</h2> -->
<h2>Everything I'm working on right now.</h2>
<br />
<!--
<p>Everything I'm working on right now.</p> -->

<div class="row">
  <div 
    class="col-12 col-sm-6 col-lg-4 mb-4" 
    *ngFor="let item of interests"
  >
    <div class="card h-100">
      <div class="card-body">
        <h5 class="card-title text-uppercase fw-semibold">
          <i [class]="item.iconClass" style="margin-right: 0.5rem;" *ngIf="item.iconClass"></i>
          {{ item.title }}
        </h5>
        <p class="card-text">{{ item.description }}</p>
      </div>
      <div class="card-footer">
        <!-- Go to /dashboard/<route> (child route) -->
        <a [routerLink]="item.route" class="btn btn-primary btn-sm">
          Learn More
        </a>
      </div>
    </div>
  </div>
</div>
